/**
 * Copyright © RINIS 2026
 * Licensed under the EUPL
 */

import 'htmx.org'
